export default __webpack_public_path__ + "static/media/pl1-bus1.3de6c1cf.jpg";